// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#nopage{\n    width: 100%;\n    text-align: center;\n    margin-top: 5em;\n    font-size: 3em;\n}", "",{"version":3,"sources":["webpack://./src/views/NoPage/NoPage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB","sourcesContent":["#nopage{\n    width: 100%;\n    text-align: center;\n    margin-top: 5em;\n    font-size: 3em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
